import { message } from 'antd';
import {
  queryIndustryApplicationLayout,
  queryIndustryApplicationLayouts,
  updateIndustryApplicationLayout
} from 'root/designer/services/api';

export default {
  namespace: 'report',
  state: { payload: {}, data: {} },
  effects: {
    *fetchLayout({ id }, { call, put }) {
      const res = yield call(queryIndustryApplicationLayout, id);
      if (!(res && res.parentId)) {
        message.error('数据请求失败');
        return false;
      }
      const parentRes = yield call(queryIndustryApplicationLayouts, res.parentId);
      if (!(parentRes && parentRes.layout)) {
        message.error('数据请求失败');
        return false;
      }
      if (res.context !== '{}') {
        yield put({
          type: 'fetchPageInfo',
          payload: {
            context: res.context,
            layout: JSON.parse(parentRes.layout)
          }
        });
      }
    },
    *updateLayout({ data }, { call }) {
      const response = yield call(updateIndustryApplicationLayout, data);
      if (response.location) {
        message.success('保存成功');
      } else {
        message.error('数据请求失败');
        return false;
      }
    }
  },
  reducers: {
    fetchPageInfo(state, { payload }) {
      const pageInfo = JSON.parse(payload.context);
      return {
        ...state,
        data: pageInfo.data,
        payload
      };
    }
  }
};
